import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

/** Renders children only for GoTruTax app admins; everyone else goes to the dashboard. */
export const AppAdminOnly: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { user, loading } = useAuth();
    if (loading) return null;
    if (!(user as any)?.is_app_admin) return <Navigate to="/dashboard" replace />;
    return <>{children}</>;
};

export default AppAdminOnly;
